import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SupplierReducer } from '../reducers';

export const selectSupplierFeature = createFeatureSelector<SupplierReducer.SupplierState>(SupplierReducer.featureName);

export const selectSupplier = createSelector(selectSupplierFeature, (state: SupplierReducer.SupplierState) => state.item);
